import { createSelector } from 'reselect';
import objectToArray from '../../../../common/utils/object-to-array';

const activitiesStateSelector = ({ entities: { activities } = {} }) =>
  activities;

export const getActivities = createSelector(
  [activitiesStateSelector],
  activities => {
    return objectToArray(activities || {});
  }
);



// WEBPACK FOOTER //
// ./src/App/account/selectors/activities/index.js